import { render, staticRenderFns } from "./InputTabs.vue?vue&type=template&id=c2f4f5a0"
import script from "./InputTabs.vue?vue&type=script&lang=js"
export * from "./InputTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports